import {
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Typography,
} from "@material-ui/core";
import React from "react";

import {
  ReportAdminDashboardColumn,
  WebTrackerReportSort,
} from "../ReportAdminDashboard";
import { WebTrackerReport } from "../types";
import DownloadReportButton from "../DownloadReportButton";

export type AllReportsTableProps = {
  columns: ReportAdminDashboardColumn[];
  reports: WebTrackerReport[];
  sort: WebTrackerReportSort;
  onSort: (column: string) => void;
  count: number;
  rowsPerPage: number;
  page: number;
  onPageChange: (newPage: number) => void;
  onRowsPerPageChange: (newRowsPerPage: number) => void;
};

function LatestReportsTable({
  columns,
  reports,
  sort,
  onSort,
  count,
  rowsPerPage,
  page,
  onPageChange,
  onRowsPerPageChange,
}: AllReportsTableProps) {
  return (
    <>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={`tracker-column-${column.name}`}
                  align={column.align}
                  style={column.tableCellStyles}
                >
                  {column.isSortable ? (
                    <TableSortLabel
                      active={sort.column === column.value}
                      direction={sort.direction}
                      onClick={() => onSort(column.value)}
                      style={column.labelStyles}
                    >
                      {column.name}
                    </TableSortLabel>
                  ) : (
                    <Typography variant="h6" style={column.labelStyles}>
                      {column.name}
                    </Typography>
                  )}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {reports.length === 0 && (
              <TableRow>
                <TableCell colSpan={7}>
                  <Typography variant="body1" align="center">
                    <em>No reports found.</em>
                  </Typography>
                </TableCell>
              </TableRow>
            )}
            {reports.map((report) => (
              <TableRow key={`tracker-report-row-${report.id}`}>
                <TableCell>{report.domain}</TableCell>
                <TableCell align="right">
                  {report.startedAt.toLocaleString()}
                </TableCell>
                <TableCell align="right">{report.numVisitedPages}</TableCell>
                <TableCell align="right">{report.numFailedPages}</TableCell>
                <TableCell align="right">
                  <Checkbox checked={report.isComplete} disabled />
                </TableCell>
                <TableCell align="right">
                  <Checkbox checked={report.isInternal} disabled />
                </TableCell>
                <TableCell align="right">
                  <DownloadReportButton reportID={report.id} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        rowsPerPageOptions={[5, 10, 20, 100]}
        component="div"
        count={count}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={(_, newPage) => onPageChange(newPage)}
        onRowsPerPageChange={(event) =>
          onRowsPerPageChange(parseInt(event.target.value, 10))
        }
      />
    </>
  );
}

export default LatestReportsTable;
